export const ITEMS_PER_PAGE = 20;
/** 카테고리 데이터 캐시 유효 시간 (5분) — SPA 내 페이지 이동 시 중복 호출 방지 */ export const CATEGORY_STALE_TIME = 5 * 60 * 1000;
export const QUERY_KEYS = {
    EDITION_CATEGORY: "edition-category",
    EDITION_CATEGORY_INFO: "edition-category-info",
    CATEGORY_PRODUCTS: "category-products"
};
